import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export const closeNodeContextMenu: GraphCommandFactory = (cmdContext) => () => {
  cmdContext.updateState((draft) => {
    draft.nodeContextMenu = null;
  });
};
